// removed by extract-text-webpack-plugin
module.exports = {"radio-text-item":"RadioText__radio-text-item","radioTextItem":"RadioText__radio-text-item","disabled":"RadioText__disabled","radio-text-input":"RadioText__radio-text-input","radioTextInput":"RadioText__radio-text-input","radio-text-item-text":"RadioText__radio-text-item-text","radioTextItemText":"RadioText__radio-text-item-text","fadeIn":"RadioText__fadeIn","hidden-spoken":"RadioText__hidden-spoken","hiddenSpoken":"RadioText__hidden-spoken"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioText/RadioText.css
// module id = 1233
// module chunks = 8